import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/atoms/Tooltip/BaseTooltip";
import { InformationCircleIcon } from "@hugeicons/core-free-icons";
import { Icon } from "@/components/atoms/Icon/Icon";
import ReactMarkdown from "react-markdown";

type Props = {
  description?: string;
  iconSize?: number;
};

export function InformationTooltip({ description, iconSize = 24 }: Props) {
  if (!description) return null;

  return (
    <TooltipProvider delayDuration={400} disableHoverableContent={false} data-sentry-element="TooltipProvider" data-sentry-component="InformationTooltip" data-sentry-source-file="InformationTooltip.tsx">
      <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="InformationTooltip.tsx">
        <TooltipTrigger asChild data-sentry-element="TooltipTrigger" data-sentry-source-file="InformationTooltip.tsx">
          {/* A native button, because an SVG cannot take focus: bound straight
              to the icon, the tooltip opened on hover only and a keyboard user
              had no way to read what it holds. Inside a <label> a click would
              be forwarded to the labelled control, which is not what pressing
              an info mark asks for. */}
          <button
            type="button"
            aria-label="More information"
            onClick={(event) => event.preventDefault()}
            data-slot="information-tooltip-trigger"
            className="inline-flex flex-none items-center justify-center rounded-full p-1 text-current hover:bg-surface-muted focus-visible:ring-2 focus-visible:ring-border-strong focus-visible:outline-none"
          >
            <Icon
              icon={InformationCircleIcon}
              data-slot="information-tooltip-icon"
              aria-hidden
              size={iconSize}
            data-sentry-element="Icon" data-sentry-source-file="InformationTooltip.tsx" />
          </button>
        </TooltipTrigger>
        <TooltipContent data-slot="information-tooltip-popup" data-sentry-element="TooltipContent" data-sentry-source-file="InformationTooltip.tsx">
          <ReactMarkdown
            components={{
              a: ({ node: _, ...props }) => (
                <a
                  target="_blank"
                  data-slot="information-tooltip-link"
                  className="pointer-events-auto text-info underline"
                  {...props}
                />
              ),
            }}
          data-sentry-element="ReactMarkdown" data-sentry-source-file="InformationTooltip.tsx">
            {description}
          </ReactMarkdown>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
